var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFilter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.0019 12.9125V18C15.0019 18.3788 14.7879 18.725 14.4491 18.8944L10.4491 20.8944C9.78421 21.2269 9.0019 20.7434 9.0019 20V12.9125L2.22794 4.63324C1.69372 3.98031 2.15827 3 3.0019 3H21.0019C21.8455 3 22.3101 3.98031 21.7759 4.63324L15.0019 12.9125ZM13.0019 17.382V12.5556C13.0019 12.3247 13.0818 12.101 13.2279 11.9223L18.8917 5H5.11214L10.7759 11.9223C10.922 12.101 11.0019 12.3247 11.0019 12.5556V18.382L13.0019 17.382Z",
    fill: "#92929D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilter);
export default __webpack_public_path__ + "static/media/filter.711a971834cfa94bbadaa363973050d2.svg";
export { ForwardRef as ReactComponent };